import type { Field, NumberInputSettings } from '../../types';

export const getMinValue = (
  inputField: Field & { inputSettings: NumberInputSettings }
): string | null | undefined => {
  if (isNaN(Number(inputField.inputSettings?.minValue))) {
    return null;
  }
  return inputField.inputSettings?.minValue;
};

export const getMaxValue = (
  inputField: Field & { inputSettings: NumberInputSettings }
): string | null | undefined => {
  if (isNaN(Number(inputField.inputSettings?.maxValue))) {
    return null;
  }
  return inputField.inputSettings?.maxValue;
};

export const toNumber = (value: number | string | undefined | null): number | undefined => {
  if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
    return undefined;
  }

  const num = Number(value);
  return isNaN(num) ? undefined : num;
};
